/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { Response } from '@neo4j-ndl/react/ai';

const headingsMarkdown = `
# Heading Level 1
This is content under heading 1.

## Heading Level 2
This is content under heading 2.

### Heading Level 3
This is content under heading 3.

#### Heading Level 4
This is content under heading 4.

##### Heading Level 5
This is content under heading 5.

###### Heading Level 6
This is content under heading 6.

---

## Document Structure Example

# Main Document Title

Brief introduction to the document.

## Introduction

This section provides an overview of what we'll cover.

### Background

Some background information about the topic.

#### Historical Context

Details about the history.

##### Key Events

- Event 1
- Event 2
- Event 3

###### Notes

Additional notes and references.

## Content Section

Main content goes here.

### Subsection A

Details for subsection A.

### Subsection B

Details for subsection B.

## Conclusion

Final thoughts and summary.

---

## Headings with Other Elements

### Code Example

\`\`\`javascript
console.log("Hello from heading section");
\`\`\`

### List Example

- Item 1
- Item 2
- Item 3

### Quote Example

> "This is a quote under a heading."

### Mixed Content

Regular paragraph with **bold** and *italic* text.
`;

export const Component = () => {
  return (
    <div className="max-w-4xl">
      <Response>{headingsMarkdown}</Response>
    </div>
  );
};

export default Component;
